export default {"src":"/_next/static/media/SoftwareAdvice.bd235c6b.svg","height":24,"width":212,"blurWidth":0,"blurHeight":0};